import { useState } from "react";
import type { Branding } from "../api/types";

interface LogoProps {
  branding: Branding | null;
}

/**
 * Renders the runtime-supplied logo image, falling back to a plain text wordmark of the brand
 * name if the image 404s or the branding hasn't loaded yet. Never references a real company's
 * asset — the path always comes from `GET /api/branding`.
 */
export function Logo({ branding }: LogoProps): JSX.Element {
  const [imageFailed, setImageFailed] = useState(false);
  const name = branding?.name || "Admin Console";

  if (!branding || imageFailed || !branding.logo_image) {
    return <span className="logo logo--text">{name}</span>;
  }

  return (
    <img
      className="logo logo--image"
      src={branding.logo_image}
      alt={name}
      onError={() => setImageFailed(true)}
    />
  );
}
